module.exports = __webpack_public_path__ + "static/img/19053B_2_R_20201008_LC.d11f51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19053B_2_R_20201008_LC.png
// module id = J04p
// module chunks = 0